import { Icon, useTheme } from '@mui/material';

import { PaletteColorsT } from 'shared/models/mui';

interface IconFromSVGProps {
  name: string;
  color: PaletteColorsT;
}
function IconFromSVG({ name, color }: IconFromSVGProps) {
  const theme = useTheme();
  const selectedColor = !color ? 'grey' : color;

  return (
    <Icon>
      <svg color={(theme.palette as any)[selectedColor as string].main}>
        <use xlinkHref={`/icons/_sprite.svg#${name}`} />
      </svg>
    </Icon>
  );
}

export default IconFromSVG;
